module.exports = __webpack_public_path__ + "static/img/stamp_06.746d5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_06.jpg
// module id = MPJo
// module chunks = 7